var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3097 1.63693C13.8413 1.28685 13.6071 1.11181 13.3485 1.04453C13.1203 0.985158 12.8797 0.985158 12.6515 1.04453C12.3929 1.11181 12.1587 1.28685 11.6903 1.63693L2.64719 8.39517C2.04269 8.84693 1.74045 9.07281 1.5227 9.35569C1.32982 9.60627 1.18614 9.88855 1.0987 10.1887C1 10.5275 1 10.8954 1 11.6313V20.9003C1 22.3353 1 23.0529 1.29065 23.601C1.54631 24.0831 1.95426 24.4751 2.45603 24.7207C3.02646 25 3.77319 25 5.26667 25H7.93333C8.3067 25 8.49339 25 8.63599 24.9302C8.76144 24.8688 8.86342 24.7708 8.92734 24.6502C9 24.5132 9 24.3338 9 23.9751V15.5195C9 14.802 9 14.4432 9.14532 14.1692C9.27316 13.9281 9.47713 13.7321 9.72801 13.6093C10.0132 13.4696 10.3866 13.4696 11.1333 13.4696H14.8667C15.6134 13.4696 15.9868 13.4696 16.272 13.6093C16.5229 13.7321 16.7268 13.9281 16.8547 14.1692C17 14.4432 17 14.802 17 15.5195V23.9751C17 24.3338 17 24.5132 17.0727 24.6502C17.1366 24.7708 17.2386 24.8688 17.364 24.9302C17.5066 25 17.6933 25 18.0667 25H20.7333C22.2268 25 22.9735 25 23.544 24.7207C24.0457 24.4751 24.4537 24.0831 24.7094 23.601C25 23.0529 25 22.3353 25 20.9003V11.6313C25 10.8954 25 10.5275 24.9013 10.1887C24.8139 9.88855 24.6702 9.60627 24.4773 9.35569C24.2596 9.07281 23.9573 8.84693 23.3528 8.39517L14.3097 1.63693Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.654355a1883d0b9f12dae4c3d4e53484.svg";
export { ForwardRef as ReactComponent };